import type { LotteryId } from '#api/shared/@types/generated/backend/graphql-schema-types'

import { useDateLotteryStore } from '../stores/dateLottery'
import { useNumberLotteryStore } from '../stores/numberLottery'
import { usePickLotteryStore } from '../stores/pickLottery'

/*
 * The three play stores share the shape every price consumer needs, so each of them resolves the
 * one that belongs to the lottery here instead of repeating the branch.
 */
export const useEditorPlayStore = (lotteryId: LotteryId) => {
  const { isDateLottery, isNumberLottery } = useLotteryType(lotteryId)

  if (isNumberLottery.value) return useNumberLotteryStore(lotteryId)
  if (isDateLottery.value) return useDateLotteryStore(lotteryId)
  return usePickLotteryStore(lotteryId)
}
